import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const TemplatesApi = createApi({
  reducerPath: "TemplatesApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["TEMPLATESAPI"],
  endpoints: (build) => ({
    // Get all templates with pagination and filters
    getTemplates: build.query({
      query: ({
        page = 1,
        search = "",
        category = "",
        status = "",
        language = "",
        limit = 10,
      }) => ({
        url: `/templates?page=${page}&search=${search}&category=${category}&status=${status}&language=${language}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEMPLATESAPI"],
    }),

    // Get template by ID
    getTemplateById: build.query({
      query: ({ id }) => ({
        url: `/templates/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEMPLATESAPI"],
    }),

    // Get template categories
    getTemplateCategories: build.query({
      query: () => ({
        url: `/templates/categories`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEMPLATESAPI"],
    }),

    // Get all templates from Meta WhatsApp
    getMetaTemplates: build.query({
      query: () => ({
        url: `/templates/meta/list`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEMPLATESAPI"],
    }),

    // Sync template status from Meta
    syncTemplateFromMeta: build.mutation({
      query: (id) => ({
        url: `/templates/${id}/sync-meta`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEMPLATESAPI"],
    }),

    // Create new template (with optional Meta submission)
    createTemplate: build.mutation({
      query: ({ data }) => ({
        url: `/templates`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEMPLATESAPI"],
    }),

    // Update template (with optional Meta resubmission)
    updateTemplate: build.mutation({
      query: ({ id, data }) => ({
        url: `/templates/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEMPLATESAPI"],
    }),

    // Update template status (Admin only)
    updateTemplateStatus: build.mutation({
      query: ({ id, status }) => ({
        url: `/templates/${id}/status`,
        method: "PATCH",
        body: { status },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEMPLATESAPI"],
    }),

    // Delete template (from both DB and Meta)
    deleteTemplate: build.mutation({
      query: ( id ) => ({
        url: `/templates/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEMPLATESAPI"],
    }),
  }),
});

export const {
  useGetTemplatesQuery,
  useGetTemplateByIdQuery,
  useGetTemplateCategoriesQuery,
  useGetMetaTemplatesQuery,
  useSyncTemplateFromMetaMutation,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useUpdateTemplateStatusMutation,
  useDeleteTemplateMutation,
  useLazyGetTemplateByIdQuery,
  useLazyGetTemplatesQuery,
  useLazyGetMetaTemplatesQuery,
} = TemplatesApi;
